"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageFeatureLoaderSym = exports.PageResourceFetcherSymbol = exports.CssFetcherSymbol = exports.PageAssetsLoaderSymbol = exports.contextIdSymbol = exports.pageIdSym = void 0;
exports.pageIdSym = Symbol('pageId');
exports.contextIdSymbol = Symbol('contextId');
exports.PageAssetsLoaderSymbol = Symbol('PageAssetsLoaderSymbol');
exports.CssFetcherSymbol = Symbol('CssFetcher');
exports.PageResourceFetcherSymbol = Symbol('PageResourceFetcher');
exports.PageFeatureLoaderSym = Symbol('PageFeatureLoader');
//# sourceMappingURL=page.js.map